import { gql } from '@apollo/client'

const ALL_REGIONS = gql`
  query RegionsQuery {
    regions_ALLS {
      _id
      description
      areaId
      isWildcard
      id
    }
  }
`

export { ALL_REGIONS }
